import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DrawerState, UIState } from '../types/uiState';

const persistedDrawerState = () => {
  let persisted = localStorage.getItem('drawerState');
  let state;
  if (persisted) {
    state = JSON.parse(persisted) as DrawerState;
  }
  return state;
};

const initialState: UIState = {
  drawerState: persistedDrawerState() || DrawerState.Expanded,
  token: localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token')!) : null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setDrawerState: (state: UIState, action: PayloadAction<DrawerState>) => {
      state.drawerState = action.payload;
      localStorage.setItem('drawerState', JSON.stringify(action.payload));
    },
    setToken: (state: UIState, action: PayloadAction<any>) => {
      state.token = action.payload;
    },
  },
});

export const { setDrawerState, setToken } = uiSlice.actions;

export default uiSlice.reducer;
